module.exports = __webpack_public_path__ + "img/pick4.a1d2c699.png";